import { Images } from "../../Images";
import Page from "../framework/Page";
import View from "../framework/View";
import PrimaryUpgradeTabBar from "./PrimaryUpgradeTabBar";

export default class UpgradeTabItemView extends View {
    /**
     * @param {string} parentId
     * @param {string} elementId 
     * @param {View} tabContentsView
     * @param {PrimaryUpgradeTabBar} tabContainerView 
     * @param {string} tabIconPath
     */
    constructor(parentId, elementId, tabContentsView, tabContainerView, tabIconPath) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {View}
         */
        this.tabContentsView = tabContentsView;

        /**
         * @constant
         * @private
         * @type {PrimaryUpgradeTabBar}
         */
        this.tabContainerView = tabContainerView;

        /**
         * @constant
         * @type {string}
         */
        this.tabIconPath = tabIconPath;

        /**
         * @type {HTMLElement}
         */
        this.tabItem = null;
    }

    /**
     * Returns the value that the display property should be set to in order to make
     * the element visible. 
     * 
     * By default this is 'block', but you should overwrite this if the element is 'display:flex', or 'display:inline-block' 
     * or something other than 'display:block'.
     * 
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block';
    }

    /**
     * @override
     * @inheritdoc
     */
    initializeView() {

        const thisRef = this;

        const id = this.getElementId();

        // <button id="minedUpgradesMenuItem" class="upgrade-tab-menu-item-selected"><img src="images/pick_40x40.png"/></button>
        // <button id="pickUpgradesMenuItem" class="upgrade-tab-menu-item"><img src="images/pick_40x40.png"/></button>

        const parent = Page.getElement(this.parentId);
        this.tabItem = Page.createElement('button', parent, id, 'upgrade-tab-menu-item');

        const tabImage = Page.createElement('img', this.tabItem, null, 'icon-container');
        tabImage.src = this.tabIconPath;

        // const tabItem = Page.getElement(id);
        // if (!tabItem) {
        //     console.log('ERROR: UpgradeTabItemView.initializeView() Failed to find tab item: ' + id);
        //     return;
        // }

        // Let the container know when this tab item has been clicked.
        this.tabItem.onclick = function () {
            thisRef.tabContainerView.onTabItemViewClicked(thisRef);
        };
        
        super.initializeView();
    }

    /**
     * @param {boolean} tabSelected 
     */
    setTabSelected(tabSelected) {

        if (tabSelected) {
            this.tabItem.className = 'upgrade-tab-menu-item-selected';
        }
        else {
            this.tabItem.className = 'upgrade-tab-menu-item';
        }
    }
}